<template>
    <div>
        <custom-page :type="'MAIN'"></custom-page>
        <!-- <section class="new_services_area">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="new_services_area_box">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="newsingle_services">
                                            <div class="newsingle_services_conts">
                                                <div class="newsingle_services_conts_img text-center">
                                                    <img src="images/servv1.png" alt="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="newsingle_services">
                                            <div class="newsingle_services_conts">
                                                <div class="newsingle_services_conts_img text-center">
                                                    <img src="images/servv2.png" alt="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="newsingle_services">
                                            <div class="newsingle_services_conts">
                                                <div class="newsingle_services_conts_img text-center">
                                                    <img src="images/servv3.png" alt="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> -->
        <newsletter-sub></newsletter-sub>
    </div>
</template>

<script>
import CustomPage from '@pages/page/CustomPage.vue'
import NewsletterSub from '@components/bora/NewsletterSub.vue'


export default{
    components:{
        CustomPage,
        NewsletterSub
    }
}
</script>



// WEBPACK FOOTER //
// BoraMainPage.vue?2ee69a9c